import {
  ActivityData,
  CheckInData,
  EditLeavePayload,
  ICreateHoliday,
  IEditHolidayPayload,
  IEditRegularization,
  IGetReport,
  IHolidayDetails,
  IHolidayList,
  IHolidayListSearch,
  IHrAttendanceListSearch,
  IHrMyAttendanceListSearch,
  IMyDailyAttendance,
  IMyRegularizationList,
  IMyRegularizationListSearch,
  IRegularizationDetails,
  IRegularizationList,
  LeaveListSearch,
  MyLeaveListData,
  MyLeaveListSearch
} from "../../../types/hr/hrInterface";
import { ApplyLeavePayload, IApplyRegularization } from "../../../types/userInterface";
import { HrActionTypes, HrActions } from "../../actionTypes/hr/hrActionTypes";

export const getDailyAttendanceList = (payload: IHrAttendanceListSearch): HrActionTypes => ({
  type: HrActions.GET_DAILY_ATTENDANCE_LIST,
  payload,
});

export const getMyDailyAttendanceList = (payload: IHrMyAttendanceListSearch): HrActionTypes => ({
  type: HrActions.GET_MY_DAILY_ATTENDANCE_LIST,
  payload,
});

export const getMyRegularizationList = (payload: IMyRegularizationListSearch): HrActionTypes => ({
  type: HrActions.GET_MY_REGULARIZATION_LIST,
  payload,
});

export const getRegularizationList = (payload: IMyRegularizationListSearch): HrActionTypes => ({
  type: HrActions.GET_REGULARIZATION_LIST,
  payload,
});

export const setDailyAttendanceList = (payload: any): HrActionTypes => ({
  type: HrActions.SET_DAILY_ATTENDANCE_LIST,
  payload,
});

export const setMyDailyAttendanceList = (payload: IMyDailyAttendance[]): HrActionTypes => ({
  type: HrActions.SET_MY_DAILY_ATTENDANCE_LIST,
  payload,
});

export const setMyRegularizationList = (payload: IMyRegularizationList[]): HrActionTypes => ({
  type: HrActions.SET_MY_REGULARIZATION_LIST,
  payload,
});

export const setRegularizationList = (payload: IRegularizationList[]): HrActionTypes => ({
  type: HrActions.SET_REGULARIZATION_LIST,
  payload,
});

export const setDailyAttendanceListCount = (payload: number): HrActionTypes => ({
  type: HrActions.SET_DAILY_ATTENDANCE_PAGE_COUNT,
  payload,
});

export const setMyDailyAttendanceListCount = (payload: number): HrActionTypes => ({
  type: HrActions.SET_MY_DAILY_ATTENDANCE_PAGE_COUNT,
  payload,
});

export const setMyRegularizationListCount = (payload: number): HrActionTypes => ({
  type: HrActions.SET_MY_REGULARIZATION_PAGE_COUNT,
  payload,
});

export const setRegularizationListCount = (payload: number): HrActionTypes => ({
  type: HrActions.SET_REGULARIZATION_PAGE_COUNT,
  payload,
});

export const getAttendanceReport = (payload: IGetReport): HrActionTypes => ({
  type: HrActions.GET_ATTENDANCE_REPORT,
  payload,
});

export const userCheckIn = (payload: CheckInData) => ({
  type: HrActions.USER_CHECK_IN,
  payload,
});

export const setUserCheckIn = (payload: boolean) => ({
  type: HrActions.SET_USER_CHECK_IN,
  payload,
});

export const setUserCheckOut = (payload: boolean) => ({
  type: HrActions.SET_USER_CHECK_OUT,
  payload,
});

export const userCheckOut = (payload: CheckInData) => ({
  type: HrActions.USER_CHECK_OUT,
  payload,
});

export const getActivity = (payload: { date?: string }) => ({
  type: HrActions.GET_ACTIVITY,
  payload,
});

export const setActivityData = (payload: ActivityData) => ({
  type: HrActions.SET_ACTIVITY,
  payload,
});

export const setleaveStatus = (payload: string) => ({
  type: HrActions.SET_LEAVE_STATUS,
  payload,
});

export const getLeaveList = (payload: LeaveListSearch): HrActionTypes => ({
  type: HrActions.GET_LEAVE_LIST,
  payload,
});

export const setLeaveList = (payload: any): HrActionTypes => ({
  type: HrActions.SET_LEAVE_LIST,
  payload,
});

export const setLeaveListCount = (payload: number): HrActionTypes => ({
  type: HrActions.SET_LEAVE_LIST_PAGE_COUNT,
  payload,
});

export const getLeaveDataById = (id: string): HrActionTypes => ({
  type: HrActions.GET_LEAVE_BY_ID,
  payload: id,
});

export const setLeaveData = (payload: any): HrActionTypes => ({
  type: HrActions.SET_LEAVE_DATA,
  payload,
});

export const editLeave = (payload: EditLeavePayload): HrActionTypes => ({
  type: HrActions.EDIT_LEAVE,
  payload,
});

export const ApplyLeaveApplication = (payload: ApplyLeavePayload) => ({
  type: HrActions.APPLY_LEAVE,
  payload,
});

export const getMyLeaveList = (payload: MyLeaveListSearch): HrActionTypes => ({
  type: HrActions.GET_MY_LEAVE_LIST,
  payload,
});

export const setMyLeaveList = (payload: MyLeaveListData[]): HrActionTypes => ({
  type: HrActions.SET_MY_LEAVE_LIST,
  payload,
});

export const setMyLeaveListCount = (payload: number): HrActionTypes => ({
  type: HrActions.SET_MY_LEAVE_LIST_PAGE_COUNT,
  payload,
});

export const applyRegularization = (data: IApplyRegularization, handleClose: () => void) => ({
  type: HrActions.APPLY_REGULARIZATION,
  payload: {
    data,
    handleClose,
  },
});

export const getRegularizationById = (id: string): HrActionTypes => ({
  type: HrActions.GET_REGULARIZATION_BY_ID,
  payload: id,
});

export const setRegularizationData = (payload: IRegularizationDetails): HrActionTypes => ({
  type: HrActions.SET_REGULARIZATION_DATA,
  payload,
});

export const editRegularization = (payload: IEditRegularization): HrActionTypes => ({
  type: HrActions.EDIT_REGULARIZATION,
  payload,
});

export const getHolidayList = (payload: IHolidayListSearch): HrActionTypes => ({
  type: HrActions.GET_HOLIDAY_LIST,
  payload,
});

export const setHolidayList = (payload: IHolidayList[]): HrActionTypes => ({
  type: HrActions.SET_HOLIDAY_LIST,
  payload,
});

export const setHolidayListCount = (payload: number): HrActionTypes => ({
  type: HrActions.SET_HOLIDAY_LIST_PAGE_COUNT,
  payload,
});

export const getHolidayDataById = (id: string): HrActionTypes => ({
  type: HrActions.GET_HOLIDAY_BY_ID,
  payload: id,
});

export const setHolidayData = (payload: IHolidayDetails): HrActionTypes => ({
  type: HrActions.SET_HOLIDAY_DATA,
  payload,
});

export const editHoliday = (payload: IEditHolidayPayload): HrActionTypes => ({
  type: HrActions.EDIT_HOLIDAY,
  payload,
});

export const createHoliday = (payload: ICreateHoliday) => ({
  type: HrActions.CREATE_HOLIDAY,
  payload,
});
